import {useLanguagesContext} from "./LanguagesContext.hook";
import {ILanguage} from "../../Interfaces/Language";

export interface ILanguagesContextState {
    loaded: boolean,
    list: Array<ILanguage>,
}

export type ILanguagesContext = ReturnType<typeof useLanguagesContext>;

/////////////////////////////////////////////////////// REDUCER ///////////////////////////////////////////////////////

export enum LanguagesContextDispatchMessageType {
    SetList, SetLoaded
}

type SetList = {
    type: LanguagesContextDispatchMessageType.SetList,
    list: Array<ILanguage>
};

type SetLoaded = {
    type: LanguagesContextDispatchMessageType.SetLoaded,
    value: boolean,
}

export type TopicsContextDispatchMessage =
    SetList |
    SetLoaded
